import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use localStorage for persistence
import themeSlice from "./slices/theme-slice";

// Persist configuration for localStorage (theme only)
const localStorageConfig = {
  key: "theme",
  storage,
  whitelist: ["theme"], // Only persist the 'theme' slice
};

// Combine reducers (we're focusing on theme only here)
const rootReducer = combineReducers({
  theme: persistReducer(localStorageConfig, themeSlice), // Persist the theme slice
});

// Configure middleware to ignore non-serializable values
const middleware = (getDefaultMiddleware: any) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"], // Ignore redux-persist actions
    },
  });

// Configure the store
export const store = configureStore({
  reducer: rootReducer,
  middleware,
});

// Configure persistor for store persistence
export const persistor = persistStore(store);

// Define RootState type (inferred type of the root state)
export type RootState = ReturnType<typeof store.getState>;
